/**
 * OurMissionPage - Generated page component.
 */
import React, { useEffect } from 'react';
import HeroCard from '../components/cards/HeroCard';
import SplitContentCard from '../components/cards/SplitContentCard';

const OurMissionPage: React.FC = () => {
  useEffect(() => {
    document.title = 'Our Mission | Kuiken Technologies LLC.';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', '');
  }, []);

  return (
    <main>

      <section className="layout-full section-padding" aria-label="MissionHero">

            <HeroCard title={"Our Mission"} subtitle={"Deliver high-quality outcomes that make the world a better place."} image={"https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=2400&q=80"} height={420} overlay={true} text_color={"#e9f0ec"} variant={"ImageOverlay"}/>
      </section>
      <section className="layout-container section-padding" aria-label="MissionValues">

            <SplitContentCard flip={false} image={"/images/ethical_image.png"} image_alt={"Ethical"} title={"Ethical"} body={"Our engineers have dedicated their careers to creating solutions that make the world a better place. We will only take on clients whose mission we believe will make the world better. "} />
            <SplitContentCard flip={true} image={"/images/innovative_image.png"} image_alt={"Innovative"} title={"Innovative"} body={"When designing robust solutions, we utilize cutting-edge technologies to solve the problems of today with the technology of tomorrow. Our innovation does not just come from our technology; our team's diverse knowledge base and unique approach to engineering design will push the limits of what is possible. "} />
            <SplitContentCard flip={false} image={"/images/tree_tech.png"} image_alt={"Sustainable"} title={"Sustainable"} body={"Sustainability is not just about the environment. Our solutions are built to last, assuring client satisfaction for years to come. "} />
      </section>
    </main>
  );
};

export default OurMissionPage;
